import { uniqueId } from 'lodash';
import { makeAutoObservable } from 'mobx';
import { IOperon } from './LacOperon';
import { BacteriaInfo, DragAndDropType } from './types';

export interface IEcoli {
  copy: (isCopyPlasmid: boolean) => IEcoli;
  id: string;
  info: BacteriaInfo;
  bacterialDNA: IOperon;
  plasmidDNA?: IOperon;
}

export default class Ecoli implements IEcoli {
  id: string;
  info: BacteriaInfo;
  bacterialDNA: IOperon;
  plasmidDNA?: IOperon;

  constructor(
    label: string,
    type: DragAndDropType,
    bacterialDNA: IOperon,
    plasmidDNA?: IOperon
  ) {
    makeAutoObservable(this);

    this.id = uniqueId();
    this.info = { label, type };
    this.bacterialDNA = bacterialDNA;
    this.plasmidDNA = plasmidDNA;
  }

  copy = (isCopyPlasmid: boolean = false): Ecoli => {
    const { bacterialDNA, info, plasmidDNA } = this;
    const { label, type } = info;
    const copy = new Ecoli(
      label,
      type,
      bacterialDNA.copy(),
      isCopyPlasmid ? plasmidDNA?.copy() : undefined
    );

    return copy;
  };

  reset = () => {
    console.log('reset ecoli');
  };
}
